export const getAvatarText = (name?: string): string => {
  const preparedName = (name ?? '').trim().toUpperCase();
  const parts = preparedName.split(' ').filter(Boolean);

  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).padEnd(2, parts[0][0]);

  return (parts[0][0] + parts[1][0]).slice(0, 2);
};
